import * as React from 'react'
import { showCustomDevTool } from '../../util'

const IsLocalHost = ({ children, type }) => {
  let isLocalHost = window.location.host.replace(/[0-9]/gi, '').replace(':', '') === 'localhost'
  if (showCustomDevTool('dev')) {
    isLocalHost = true
  }
  return <section style={{ width: '100%' }}>{isLocalHost && <>{children}</>}</section>
}
export default IsLocalHost
